import "../styles/remote-store-types.css";
import React, { useState, useEffect } from "react";
import ServiceController from "../services/service-controller";
import { Skeleton } from "primereact/skeleton";

export default function RemoteStoreTypes(props) {
	const serviceController = new ServiceController();
	const [isLoading, setIsLoading] = useState(false);
	const [categories, setCategories] = useState([]);

	const getData = async function () {
		try {
			setIsLoading(true);

			//> Get categories
			const categoriesResult = await serviceController.getRemoteCategories();
			if (categoriesResult.isSuccess === false) throw categoriesResult.message;
			setCategories(categoriesResult.value);
			//>
		} catch (error) {
			alert(error.toString());
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div>
			{isLoading === true && (
				<>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
				</>
			)}
			<ul className="store-types">
				{categories.map((item) => (
					<li>
						<a href={"/#/remote-stores?category=" + item.code}>
							<img src={item.imageUrl} />
							<span>{item.name}</span>
						</a>
					</li>
				))}
			</ul>
		</div>
	);
}
